
import { useState } from 'react';
import TopBanner from './components/TopBanner';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import BeforeAfter from './components/BeforeAfter';
import Pricing from './components/Pricing';
import Portfolio from './components/Portfolio';
import TravelCTA from './components/TravelCTA';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

export default function HomePage() {
  const [bannerVisible, setBannerVisible] = useState(true);

  return (
    <div className="min-h-screen bg-white">
      <TopBanner visible={bannerVisible} onClose={() => setBannerVisible(false)} />
      <Navbar topOffset={bannerVisible} />
      <Hero />
      <HowItWorks />
      <BeforeAfter />
      <Pricing />
      <Portfolio />
      <TravelCTA />
      <FAQ />
      <Footer />
    </div>
  );
}
